import React from 'react'
import { CFView, Text } from 'components'
import { css } from 'emotion'
import { pointsMeter, rewardbg, rewardDefault } from 'images'

const RewardsLoadedView = ({
  pointsMeterWidth,
  imageUrl,
  LeftArrowButtonElement,
  RightArrowButtonElement,
  points,
  maxPoints,
  requiredPoints,
  name,
  RedeemRewardButtonElement,
}) => (
  <div className={styles.rewardContainer}>
    <div className={styles.reward}>
      {imageUrl ? (
        <img className={styles.image} src={imageUrl} alt="Reward" />
      ) : (
        <img
          className={styles.rewardDefault}
          src={rewardDefault}
          alt="Reward"
        />
      )}
    </div>
    {LeftArrowButtonElement}
    {RightArrowButtonElement}
    <div className={styles.meter}>
      <div
        className={styles.progress}
        style={{
          width: `${pointsMeterWidth * 30.8}rem`,
          transition: 'width 2s',
        }}
      >
        <img src={pointsMeter} alt="Meter" />
      </div>
    </div>
    <div className={styles.pointsText}>
      <Text h6 bold dark>
        {points} / {maxPoints}
      </Text>
    </div>
    <Text h2 bold dark className={styles.requiredPoints}>
      {requiredPoints === 0 ? 'FREE' : `${requiredPoints} Points`}
    </Text>
    <CFView className={styles.name}>
      <Text h3 bold dark center>
        {name ? name.toUpperCase() : ''}
      </Text>
    </CFView>
    <CFView className={styles.redeemButton}>{RedeemRewardButtonElement}</CFView>
  </div>
)

const styles = {
  rewardContainer: css({
    position: 'relative',
    height: '100%',
    width: '100%',
    background: `url(${rewardbg}) no-repeat`,
    backgroundSize: 'contain',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }),
  reward: css({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }),
  image: css({
    position: 'relative',
    top: '-1.8rem',
    width: '18rem',
    borderRadius: '10rem',
  }),
  rewardDefault: css({
    position: 'relative',
    left: '.7rem',
    bottom: '2rem',
    objectFit: 'contain',
    width: '17rem',
  }),
  requiredPoints: css({
    position: 'absolute',
    top: '13rem',
  }),
  name: css({
    width: '100%',
    position: 'absolute',
    bottom: '15rem',
    textAlign: 'center',
  }),
  redeemButton: css({
    position: 'absolute',
    bottom: '5rem',
  }),
  meter: css({
    position: 'absolute',
    top: '3rem',
    left: '3.4rem',
  }),
  progress: css({
    overflow: 'hidden',
  }),
  pointsText: css({
    position: 'absolute',
    top: '6.7rem',
    right: '4.4rem',
  }),
}

export default RewardsLoadedView
